import { useMemo } from "react";
import { Box } from "@chakra-ui/react";
import { Step } from "chakra-ui-steps";

type BaseStepProps = {
  label: string;
  index?: number;
  isCompletedStep?: boolean;
  isCurrentStep?: boolean;
  isLastStep?: boolean;
};
const BaseStep: React.FC<BaseStepProps> = (props) => {
  const color = useMemo(() => {
    return props.isCompletedStep
      ? "#10B981"
      : props.isCurrentStep
      ? "#27489B"
      : "#94A3B8";
  }, [props.isCurrentStep, props.isCompletedStep]);

  return (
    <Step
      {...props}
      height={"16px"}
      className="step"
      sx={{
        "div > div:first-of-type": {
          width: "24px",
          height: "24px",
          border: "none",
          display: "flex",
          borderRadius: "50%",
          backgroundColor: color,
          justifyContent: "center",
          alignItems: "center",
        },
        "div > div:first-of-type > span": {
          color: "white",
          fontFamily: "Inter",
          fontWeight: 500,
          lineHeight: "20px",
          fontSize: "14px",
        },
        "div > div:first-of-type > svg": {
          height: "12px !important",
        },
        "> div:nth-child(1)": {
          flexDirection: "column",
        },
        "> div:nth-child(2)": {
          display: "none",
        },
        "@media (min-width: 768px)": {
          "> div:nth-child(2)": {
            display: "block",
          },
          "> div:nth-child(1)": {
            flexDirection: "row",
          },
          "div > div:first-of-type": {
            width: "28px",
            height: "28px",
          },
        },
      }}
      label={
        <Box
          className="label"
          fontFamily={"Inter"}
          fontSize={"14px"}
          lineHeight={"20px"}
          color={color}
        >
          {props.label}
        </Box>
      }
    />
  );
};

export { BaseStep };
